/**
 * @generated SignedSource<<9fc95eac239e66e4a4d1f5a50cdf605b>>
 * @relayHash b07be25c82d6249b03f2517f0b4a766f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 28bb276fde23dfb77aca8e9a568d1d41ea189c8fe3d34e59b27b7016a7de4e86

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcVirtualAgentLandingQuery } from './srcVirtualAgentLandingQuery.graphql';

import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';
import vsaAdoptionStage1Enabled_provider from '@atlassian/jira-relay-provider/src/vsa-adoption-stage-1.relayprovider';

const node: PreloadableConcreteRequest<srcVirtualAgentLandingQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "28bb276fde23dfb77aca8e9a568d1d41ea189c8fe3d34e59b27b7016a7de4e86",
    "metadata": {},
    "name": "srcVirtualAgentLandingQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcvsaadoptionstage1relayprovider": vsaAdoptionStage1Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
